
import { defineComponent } from "vue";

import { mapState, mapActions } from "pinia";
import { useBillStore } from "@/stores/BillStore";
import openURL from 'quasar/src/utils/open-url.js';;

export default defineComponent({
  computed: {
    ...mapState(useBillStore, ["waitPayment", "redirectUrl"]),
  },
  methods: {
    ...mapActions(useBillStore, ["cancelPayment"]),
    redirect() {
      openURL(this.redirectUrl);
    },
  },
});
